import React from "react";
import { Button } from "../Controls/Button";

interface WizardFooterProps {
  onNext: () => void;
  onBack: () => void;
  canGoBack: boolean;
  canGoNext: boolean;
  isLastStep: boolean;
  saving: boolean;
  doneButtonText: string;
}

export const WizardFooter: React.FC<WizardFooterProps> = ({
  onNext,
  onBack,
  canGoBack,
  canGoNext,
  isLastStep,
  saving,
  doneButtonText,
}) => {
  return (
    <div className="flex justify-between bg-gray-50 px-5 py-3 tall:py-5" data-wizard-footer>
      <Button onClick={onBack} disabled={saving || !canGoBack} kind="secondary" data-wizard-button="back">
        Back
      </Button>
      <Button
        disabled={saving || !canGoNext}
        spinner={saving}
        onClick={onNext}
        data-wizard-button={isLastStep ? "done" : "next"}
      >
        {isLastStep ? doneButtonText : "Next"}
      </Button>
    </div>
  );
};
